import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import { displayName } from './util';
import { useTenant } from './TenantContext';
import { SUNRISE_THEME } from './themes/sunrise/SunriseTheme';
import { VERSATEL_THEME } from './themes/versatel/VersatelTheme';
import { TELENET_THEME } from './themes/telenet/TelenetTheme';

LicenseInfo.setLicenseKey(
  'b08e0b94b23159a76949b9f741c0c5c9Tz0xMjk0NTMsRT0xODEwOTQzOTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI='
);

interface ThemeProviderProps {
  children?: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const tenant = useTenant();

  let theme = SUNRISE_THEME;

  switch (tenant) {
    case 'sunrise':
      theme = SUNRISE_THEME;
      break;
    case 'versatel':
      theme = VERSATEL_THEME;
      break;
    case 'telenet':
      theme = TELENET_THEME;
      break;
    default:
      throw Error(`No theme exists for tenant: ${tenant}`);
  }

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

displayName(ThemeProvider, 'ThemeProvider');
